/**
 * Analytics tracking helper for Meta Pixel (fbq) and Google Analytics (gtag).
 */

// Deduplication cache for rapid successive contact clicks
let lastContactTime = 0;
let lastContactKey = '';

/**
 * Track PageView event on SPA route changes.
 * @param {string} path - URL path (e.g. /product/123)
 */
export const trackPageView = (path) => {
    try {
        if (typeof window.fbq === 'function') {
            window.fbq('track', 'PageView');
        }
        if (typeof window.gtag === 'function') {
            window.gtag('event', 'page_view', {
                page_path: path || (window.location.pathname + window.location.search),
                page_title: document.title,
                page_location: window.location.href
            });
        }
    } catch (err) {
        console.warn('Analytics PageView tracking error:', err);
    }
};

/**
 * Track Lead event (e.g. form submissions, sign up, order placement).
 * @param {Object} params - Event parameters
 */
export const trackLead = (params = {}) => {
    try {
        if (typeof window.fbq === 'function') {
            window.fbq('track', 'Lead', params);
        }
        if (typeof window.gtag === 'function') {
            window.gtag('event', 'generate_lead', params);
        }
    } catch (err) {
        console.warn('Analytics Lead tracking error:', err);
    }
};

/**
 * Track Contact event (e.g. WhatsApp, phone, email, contact buttons).
 * @param {Object} params - Event parameters (e.g. { method: 'WhatsApp', location: 'Footer' })
 */
export const trackContact = (params = {}) => {
    const now = Date.now();
    const key = JSON.stringify(params);

    // Prevent duplicate triggers within 500ms
    if (key === lastContactKey && (now - lastContactTime) < 500) {
        return;
    }
    lastContactTime = now;
    lastContactKey = key;

    try {
        if (typeof window.fbq === 'function') {
            window.fbq('track', 'Contact', params);
        }
        if (typeof window.gtag === 'function') {
            window.gtag('event', 'contact', params);
        }
    } catch (err) {
        console.warn('Analytics Contact tracking error:', err);
    }
};
